import * as DynoRepository from '../repository/DynoRepository'

export const getWizardDynoData = async (id) => {
    return await DynoRepository.getWizardDynoData(id);
};